var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#183059"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 7.04166C15.0837 7.04166 14.1886 7.31318 13.4273 7.82189C12.6659 8.3306 12.0725 9.05365 11.7221 9.8996C11.3717 10.7456 11.28 11.6764 11.4587 12.5745C11.6373 13.4725 12.0782 14.2975 12.7257 14.9449C13.3732 15.5924 14.1981 16.0333 15.0962 16.212C15.9942 16.3906 16.9251 16.2989 17.771 15.9485C18.617 15.5981 19.34 15.0047 19.8487 14.2434C20.3575 13.482 20.629 12.5869 20.629 11.6713C20.629 10.4434 20.1412 9.26587 19.273 8.39764C18.4048 7.52942 17.2272 7.04166 15.9993 7.04166ZM15.9993 14.4491C15.45 14.4491 14.9129 14.2862 14.4561 13.9809C13.9993 13.6757 13.6433 13.2419 13.433 12.7343C13.2228 12.2267 13.1678 11.6682 13.2749 11.1294C13.3821 10.5905 13.6467 10.0956 14.0352 9.7071C14.4236 9.31862 14.9186 9.05406 15.4574 8.94688C15.9963 8.8397 16.5548 8.89471 17.0624 9.10495C17.5699 9.3152 18.0038 9.67123 18.309 10.128C18.6142 10.5848 18.7771 11.1219 18.7771 11.6713C18.7771 12.408 18.4845 13.1145 17.9635 13.6355C17.4426 14.1564 16.7361 14.4491 15.9993 14.4491ZM24.3327 24.6343V23.7083C24.3327 21.9893 23.6498 20.3407 22.4343 19.1252C21.2188 17.9097 19.5702 17.2268 17.8512 17.2268H14.1475C12.4285 17.2268 10.7799 17.9097 9.5644 19.1252C8.34888 20.3407 7.66602 21.9893 7.66602 23.7083V24.6343H9.51787V23.7083C9.51787 22.4805 10.0056 21.3029 10.8739 20.4347C11.7421 19.5665 12.9196 19.0787 14.1475 19.0787H17.8512C19.0791 19.0787 20.2566 19.5665 21.1248 20.4347C21.9931 21.3029 22.4808 22.4805 22.4808 23.7083V24.6343H24.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertUser);
export default __webpack_public_path__ + "static/media/alert_user.5db10d75a62d783c503a03f7baccbb65.svg";
export { ForwardRef as ReactComponent };